import { BaseEdge, EdgeLabelRenderer, type EdgeProps, getSmoothStepPath } from "@xyflow/react";
import { X } from "lucide-react";

interface ManagerEdgeData extends Record<string, unknown> {
  onDelete?: (targetId: string) => void;
}

export function ManagerEdge(props: EdgeProps) {
  const {
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    target,
    data,
  } = props;

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const edgeData = data as ManagerEdgeData | undefined;

  return (
    <>
      <BaseEdge path={edgePath} style={style} interactionWidth={20} />
      <EdgeLabelRenderer>
        <button
          type="button"
          className="nodrag nopan absolute flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-destructive-foreground opacity-0 hover:opacity-100 transition-opacity shadow-sm cursor-pointer"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
          }}
          onClick={() => edgeData?.onDelete?.(target)}
        >
          <X className="h-3 w-3" />
        </button>
      </EdgeLabelRenderer>
    </>
  );
}
